module.exports = __webpack_public_path__ + "static/media/R_AngelsOfAether_Promo_201.d06d9bcb.jpg";